module.exports = __webpack_public_path__ + "img/title.bea7556a.svg";